<div class="table-title card-header" [style.border-bottom-color]="state === 'collapsed' ? '$main-orange' : null">
  <div class=" table-header d-flex">
    <h4 class="table-title">
      <a>
        <i [ngClass]="state === 'collapsed' ? 'fa fa fa-arrow-down' : 'fa fa fa-arrow-up'" (click)="toggle()"></i>
        {{TABLE_TITLE}}
      </a>
    </h4>
    <a>
      <button type="button" class="btn btn-light" *ngIf="tableInfoExists" (click)="openInfoDialog()">
        <i class="fa fa-info-circle fa-sm"></i>
      </button>
    </a>
  </div>
</div>

<div class="table-responsive" [@detailExpand]="state">

  <div class="alert" role="alert" [ngClass]="tableDataStatus.errorCSS()" *ngIf="tableDataStatus.isFailed()">
    {{tableDataStatus.errorMessage}}
  </div>

  <div class="alert" role="alert" [ngClass]="tableDataStatus.infoCSS()" *ngIf="tableDataStatus.thereIsInfo()">
    {{tableDataStatus.infoMessage}}
  </div>

  <table class="table footable" data-breakpoints='{ "xs": 480, "sm": 768, "md": 992, "lg": 1200, "xl": 1400 }'
  matSort (matSortChange)="triggerSorting($event)">
    <thead class="thead-dark">
      <tr>
        <th mat-sort-header="{{header[0]}}" *ngFor="let header of TABLE_SORT_HEADERS">
          {{header[1]}}
        </th>
        <th></th>
      </tr>
    </thead>

    <tbody>
      <tr *ngIf="loader.isActive()">
        <td colspan="12">
          <div class="loader-container">
            <app-loader></app-loader>
          </div>
        </td>
      </tr>

      <ng-container *ngIf="tableDataStatus.isSuccesfully()">
        <tr *ngFor="let record of records">
          <td>
            <a [routerLink]="['/menu/scheda-certificato']" [queryParams]="{ isin: record.isin }">
              {{record.isin ? record.isin : '--'}}
            </a>
          </td>
          <td>{{record.nome ? record.nome : '--'}}</td>

          <td *ngIf="record.sottostante">
            <a [routerLink]="[ '/menu/sottostante']"
              [queryParams]="{ sottostante: record.sottostante}">{{record.sottostante ? record.sottostante : '--'}}</a>
          </td>
          <td *ngIf="!record.sottostante">
            {{'--'}}
          </td>

          <td>{{record.data ? (record.data | date: 'dd/MM/yyyy') : '--'}}</td>
          <td>{{record.prezzosott ? (record.prezzosott | number:'1.0-4':'fr') : '--' }}</td>
          <td>{{record.trigger ? (record.trigger | number:'1.0-2':'fr') : '--'}}</td>

          <td>{{record.prezzocert ? (record.prezzocert | currency:currencySymbol(record.valuta):'symbol':'1.2-2':localeCurrency(record.valuta)) : '--'}}</td>

          <td [style.color]="(record.datrigger * -1) < 0 ? 'red' : undefined">
            {{record.datrigger ? (record.datrigger * -1 | number:'1.0-2':'it') + ' %' : '--'}}
          </td>
          <td [style.color]=" record.upside < 0 ? 'red' : 'null'">
            {{record.upside ? (record.upside | number:'1.0-2':'it') + ' %' : '--'}}
          </td>
          <td>
            <a (click)="addIsinToWatchlist(record.isin)" matTooltip="Aggiungi isin ad una watchlist">
              <img [src]="'assets/images/icons/addToWatchlistGlassesSmall.png'" alt="Aggiungi alla watchlist" class="watchlistIcon">
            </a>
          </td>
        </tr>
      </ng-container>
    </tbody>

    <tfoot *ngIf="!loader.isActive()" class="footer-view-all">
      <tr>
        <td colspan="100%">
          <a class="nav-link" [routerLink]="['/menu/next-valutation-date']">
            <i class="fa fa-plus"></i> Visualizza tutti
          </a>
        </td>
      </tr>
    </tfoot>
  </table>

</div>
